// extracted by mini-css-extract-plugin
export var desktop = "1025px";
export var mobile = "360px";
export var tablet = "768px";